import { useState } from 'react';
import { useRemoveProfileContributions } from 'api';
import { AnonymisationType } from 'types/types';

type UseProfileContributorsProps = {
  learnerId: string;
  profileId: string;
  isDFCProfile: boolean;
};

export const useProfileContributors = ({
  learnerId,
  profileId,
  isDFCProfile,
}: UseProfileContributorsProps) => {
  const [editContributorsOpen, setEditContributorsOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [editContributorsList, setEditContributorsList] = useState<string[]>(
    [],
  );
  const [anonymisationType, setAnonymisationValue] = useState<
    AnonymisationType | undefined
  >(isDFCProfile ? 'NAMED' : undefined);

  const {
    mutate: removeProfileContributors,
    status: removeProfileContributorsStatus,
  } = useRemoveProfileContributions();

  const onContributorCheckChange = (check: boolean, contributorId: string) => {
    if (check === true) {
      setEditContributorsList((previous) => [...previous, contributorId]);
    } else {
      setEditContributorsList((previous) => [
        ...previous.filter((id) => id !== contributorId),
      ]);
    }
  };

  const onContributorEditCancel = () => {
    setEditContributorsOpen(false);
    setEditContributorsList([]);
  };

  const closeError = () => {
    onContributorEditCancel();
    setErrorModalOpen(false);
  };

  const onHandleRemoveProfileContributors = () => {
    removeProfileContributors(
      {
        learnerId,
        profileId,
        contributorsIds: editContributorsList,
      },
      {
        onSuccess: () => {
          setEditContributorsOpen(false);
          setEditContributorsList([]);
        },
        onError: () => {
          setEditContributorsOpen(false);
          setErrorModalOpen(true);
        },
      },
    );
  };

  const handleAnonymisationSwitchChange = (value: boolean) => {
    setAnonymisationValue(value ? 'ANONYMISED' : 'NAMED');
  };

  return {
    editContributorsOpen,
    setEditContributorsOpen,
    editContributorsList,
    onContributorCheckChange,
    onContributorEditCancel,
    onHandleRemoveProfileContributors,
    removeProfileContributorsStatus,
    errorModalOpen,
    closeError,
    anonymisationType,
    handleAnonymisationSwitchChange,
  };
};
